import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-root">
        <div className="navigation-container">
          <a href=" /" className="navigation-link1">
            <div
              aria-label="Sycorax Cats Home"
              className="navigation-thq-navigation-brand-elm1 navigation-brand"
            >
              <div className="navigation-thq-navigation-logo-wrapper-elm1 navigation-logo-wrapper">
                <img
                  alt="image"
                  src="/side%20profile%20transparent%20cleaned%20up-200h.png"
                  className="navigation-image navigation-logo-icon"
                />
              </div>
              <span className="navigation-thq-section-title-elm1 section-title navigation-brand-name">
                  Sycorax Cats
              </span>
            </div>
          </a>
          <div className="navigation-desktop-menu">
            <ul className="navigation-links">
              <Link to="/" className="navigation-navlink1">
                <li className="navigation-li1">
                  <div className="navigation-link">
                    <span className="navigation-text1">Home</span>
                  </div>
                </li>
              </Link>
              <li>
                <Link to="/queen">
                  <div className="navigation-thq-navigation-link-elm2 navigation-link">
                    <span className="navigation-text2">Our Queen</span>
                  </div>
                </Link>
              </li>
              <Link to="/kittens" className="navigation-navlink3">
                <li className="navigation-li3">
                  <div className="navigation-link">
                    <span className="navigation-text3">Kittens</span>
                  </div>
                </li>
              </Link>
              <Link to="/queen" className="navigation-navlink4">
                <li></li>
              </Link>
            </ul>
            <Link to="/contact-us" className="navigation-navlink5">
              <div className="navigation-thq-btn-elm1 btn-primary btn navigation-cta">
                <span className="navigation-thq-text-elm">Contact Us</span>
              </div>
            </Link>
          </div>
          <button
            id="navToggle"
            aria-label="Open navigation menu"
            aria-controls="mobileOverlay"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              fill="none"
              width="28"
              xmlns="http://www.w3.org/2000/svg"
              height="28"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="mobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <div className="navigation-brand">
            <div className="navigation-logo-wrapper">
              <svg
                width="32"
                xmlns="http://www.w3.org/2000/svg"
                height="32"
                viewBox="0 0 24 24"
                className="navigation-logo-icon"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 5c.67 0 1.35.09 2 .26c1.78-2 5.03-2.84 6.42-2.26c1.4.58-.42 7-.42 7c.57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44c0 0-1.89-6.42-.5-7s4.72.23 6.5 2.23A9 9 0 0 1 12 5m-4 9v.5m8-.5v.5"></path>
                  <path d="M11.25 16.25h1.5L12 17z"></path>
                </g>
              </svg>
            </div>
            <span className="section-title navigation-brand-name">
              Sycorax Cats
            </span>
          </div>
          <button
            id="navClose"
            aria-label="Close navigation menu"
            className="navigation-mobile-close"
          >
            <svg
              fill="none"
              width="28"
              xmlns="http://www.w3.org/2000/svg"
              height="28"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6L6 18M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <ul className="navigation-overlay-list">
            <li>
              <a href="Homepage">
                <div className="navigation-overlay-link">
                  <span>Home</span>
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m9 18l6-6l-6-6"></path>
                  </svg>
                </div>
              </a>
            </li>
            <li>
              <a href="Homepage">
                <div className="navigation-overlay-link">
                  <span>Our Queen</span>
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m9 18l6-6l-6-6"></path>
                  </svg>
                </div>
              </a>
            </li>
            <li>
              <a href="Homepage">
                <div className="navigation-overlay-link">
                  <span>Kittens</span>
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m9 18l6-6l-6-6"></path>
                  </svg>
                </div>
              </a>
            </li>
            <Link to="/contact-us" className="navigation-navlink6">
              <li>
                <div className="navigation-overlay-link">
                  <span>Contact Us</span>
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m9 18l6-6l-6-6"></path>
                  </svg>
                </div>
              </li>
            </Link>
          </ul>
          <div className="navigation-overlay-footer">
            <a href="Homepage" className="navigation-link5">
              <div className="navigation-overlay-cta btn-primary btn-lg btn">
                <span>Contact Me</span>
              </div>
            </a>
            <p className="navigation-registry-tag section-content">
              GCCF Registered Breeder
            </p>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const navToggle = document.getElementById("navToggle")
  const navClose = document.getElementById("navClose")
  const mobileOverlay = document.getElementById("mobileOverlay")
  const overlayLinks = document.querySelectorAll(".navigation-overlay-link")

  function openMenu() {
    mobileOverlay.classList.add("is-active")
    navToggle.setAttribute("aria-expanded", "true")
    document.body.style.overflow = "hidden"
  }

  function closeMenu() {
    mobileOverlay.classList.remove("is-active")
    navToggle.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""
  }

  navToggle.addEventListener("click", openMenu)
  navClose.addEventListener("click", closeMenu)

  overlayLinks.forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileOverlay.classList.contains("is-active")) {
      closeMenu()
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
